import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { onUiChange, getUiState } from "@/lib/uiState";

// Subtle back-to-top control — appears only after meaningful scroll depth,
// Lenis-aware, keyboard accessible, reduced-motion safe. Lifts itself above the
// mobile sticky reservation CTA (Thailand) so neither covers the other.
export default function BackToTop() {
  const [show, setShow] = useState(false);
  const [ctaUp, setCtaUp] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    const unsub = onUiChange((s) => setCtaUp(!!s.stickyCta));
    setCtaUp(!!getUiState().stickyCta);
    return () => { window.removeEventListener("scroll", onScroll); unsub(); };
  }, []);
  const up = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.1 });
    else window.scrollTo({ top: 0, behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
  };
  return (
    <button data-testid="back-to-top" onClick={up} aria-label="Back to top" aria-hidden={!show} tabIndex={show ? 0 : -1}
      className={`fixed ${ctaUp ? "bottom-24 md:bottom-6" : "bottom-6"} right-6 z-50 w-11 h-11 border border-gold/50 bg-noir/80 backdrop-blur-md text-gold flex items-center justify-center transition-[opacity,transform,color,background-color,border-color,bottom] duration-500 hover:bg-gold hover:text-black ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"}`}>
      <ArrowUp size={17} />
    </button>
  );
}
